export default __webpack_public_path__ + "static/media/product_videos.c9c65b0f.mp4";